import { IAuthState } from '../../../../../services/auth/models';
import * as React from 'react';
import {flow, isEmpty, map} from 'lodash';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import { isUndefined } from 'util';
import {Button, Col, ControlLabel, Form, FormGroup, Modal, Row} from 'react-bootstrap';
import FieldFormControl from '../../../../../components/FieldFormControl';
import FaSpinner from 'react-icons/fa/spinner';
import {translatePasswordError} from '../../../../../util/helpers';
import Cards from 'react-credit-cards';
import {isLengthBetween, isLuhnHappy, isRequired} from '../../../../../util/validators';

interface IUpdateCardFormProps {
  auth: IAuthState;
  onCloseModal: any;
  handleSubmit: any;
  dispatch: any;
  change: any;
  isSaved: boolean;
  isSubmitting: boolean;
  cvv: string;
  cardName: string;
  cardNumber: string;
  expiryMonth: string;
  expiryYear: string;
}

interface IUpdateCardFormState {
  openModal: boolean;
  canSave: boolean;
  activeField?: string;
}

class UpdateCardForm extends React.Component<IUpdateCardFormProps, IUpdateCardFormState> {
  public state = {
    openModal: false,
    canSave: false,
    activeField: null,
  };

  public componentWillReceiveProps(nextProps: IUpdateCardFormProps) {
    const allFieldsFilled = ! isUndefined(nextProps.cvv) &&
      nextProps.cvv.length > 0 && ! isUndefined(nextProps.cardName) &&
      nextProps.cardName.length > 0 && ! isUndefined(nextProps.cardNumber) &&
      nextProps.cardNumber.length > 0 && ! isUndefined(nextProps.expiryMonth) &&
      nextProps.expiryMonth.length > 0 && ! isUndefined(nextProps.expiryYear) &&
      nextProps.expiryYear.length > 0;

    if (this.state.canSave !== allFieldsFilled) {
      this.setState({
        canSave: allFieldsFilled,
      });
    }
  }

  private updateActiveField = (name) => () => {
    this.setState({
      activeField: name,
    });
  }

  public render() {
    const {
      isSaved,
      onCloseModal,
      handleSubmit,
      auth,
      cvv,
      cardName,
      cardNumber,
      expiryMonth,
      expiryYear,
    } = this.props;
    const { activeField } = this.state;

    const lessThan = (limit) => (value, previousValue, allValues) => {
      return value.length < limit ? value : previousValue;
    };

    return(
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <Modal.Body>
          {isSaved && (
            <div>
              {auth && auth.error && ! isEmpty(auth.error.update) ? (
                <div className="alert alert-danger" style={{marginTop: '10px'}}>
                  {map(auth.error.update, (error, key) => {
                    return <p key={key}>{translatePasswordError(error.detail)}</p>;
                  })}
                </div>
              ) : (
                <p>Vos modifications ont bien été prises en compte.</p>
              )}
            </div>
          )}
          {!isSaved && (
            <div>
              <div className="margin-bottom">
                <Cards
                  cvc={cvv || ''}
                  focused={activeField}
                  name={cardName || ''}
                  number={cardNumber || ''}
                  expiry={(expiryMonth || '') + (expiryYear || '')}
                  locale={{valid: 'valable jusqu\'à'}}
                  placeholders={{name: 'VOTRE NOM ICI'}}
                />
              </div>
              <FormGroup controlId="card-number" className="margin-top">
                <Col componentClass={ControlLabel} sm={3}>
                  Numéro de carte:
                </Col>
                <Col sm={9}>
                  <Field
                    type="cleave"
                    name="cardNumber"
                    component={FieldFormControl}
                    validate={[isRequired, isLuhnHappy()]}
                    onFocus={this.updateActiveField('number')}
                    cleaveOptions={{ creditCard: true, creditCardStrictMode: true }}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="expiry-dates">
                <Col componentClass={ControlLabel} sm={3}>
                  Date d'expiration:
                </Col>
                <Col sm={4}>
                  <Row>
                    <Col sm={6}>
                      <Field
                        placeholder="mm"
                        normalize={lessThan(3)}
                        validate={[isRequired]}
                        name={'card.expiryMonth'}
                        component={FieldFormControl}
                        onFocus={this.updateActiveField('expiry')}
                      />
                    </Col>
                    <Col sm={6}>
                      <Field
                        placeholder="yy"
                        normalize={lessThan(3)}
                        validate={[isRequired]}
                        name={'card.expiryYear'}
                        component={FieldFormControl}
                      />
                    </Col>
                  </Row>
                </Col>
              </FormGroup>
              <FormGroup controlId="expiry-dates">
                <Col componentClass={ControlLabel} sm={3}>
                  Nom du titulaire de la carte:
                </Col>
                <Col sm={9}>
                  <Field
                    name="card.name"
                    validate={[isRequired]}
                    component={FieldFormControl}
                    onFocus={this.updateActiveField('name')}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="cvv">
                <Col componentClass={ControlLabel} sm={3}>
                  CVV:
                </Col>
                <Col sm={2}>
                  <Field
                    name="cvv"
                    normalize={lessThan(5)}
                    component={FieldFormControl}
                    onBlur={this.updateActiveField('')}
                    onFocus={this.updateActiveField('cvc')}
                    validate={[
                      isRequired,
                      isLengthBetween([3, 4], 'The CVC/CVV incorrect, please type it in again.'),
                    ]}
                  />
                </Col>
              </FormGroup>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <div>
              {(this.state.canSave && !this.props.isSaved) && (
                <Button
                  bsStyle="primary"
                  type="submit"
                  disabled={this.props.isSubmitting}
                >
                  {this.props.isSubmitting && (
                    <FaSpinner className="fa-spin"/>
                  )}
                  <span>Sauvegarder</span>
                </Button>
              )}

              {!this.props.isSubmitting && (
                <Button
                  bsStyle="primary"
                  onClick={onCloseModal}
                  disabled={this.props.isSubmitting}
                >
                  {this.props.isSaved ? 'Fermer' : 'Annuler'}
                </Button>
              )}
            </div>
          </div>
        </Modal.Footer>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'customer1',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('customer1');

    return component;
  },
  connect(
    (state: IStore) => {
      const cvv = selector(state, 'cvv');
      const cardName = selector(state, 'card.name');
      const cardNumber = selector(state, 'cardNumber');
      const expiryYear = selector(state, 'card.expiryYear');
      const expiryMonth = selector(state, 'card.expiryMonth');

      return {
        cvv,
        cardName,
        cardNumber,
        expiryYear,
        expiryMonth,
        auth: state.auth,
        quote: state.quote,
      };
    },
  ),
])(UpdateCardForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/UpdateCardModal/UpdateCardModalForm/index.tsx